<template>
    <div>
        <Box @close="close({})">
            <template #top>Nueva Asignación</template>
            <template #center>
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-title-1">Datos</div>
                        <div class="nj-gridx">
                            <InputSelect label="Almacen"
                                         v-model="asignacion_items.alm_id"
                                         :source="almacenes"
                                         itemKey="alm_id"
                                         itemValue="alm_id"
                                         :filterFunction="filterAlmacen"
                                         :labelFunction="labelAlmacen"
                                         @selectItem="asignarPoryecto($event)">
                            </InputSelect>
                            <InputSelect label="Solicitante"
                                         v-model="asignacion_items.emp_solicitante"
                                         :source="solicitantes"
                                         itemKey="epr_id"
                                         itemValue="emp_id"
                                         :filterFunction="filterUsuario"
                                         :labelFunction="labelEmpleado">
                            </InputSelect>
                            <InputSelect label="Autorizador"
                                         v-model="asignacion_items.emp_autorizador"
                                         :source="autorizadores"
                                         itemKey="epr_id"
                                         itemValue="emp_id"
                                         :filterFunction="filterUsuario"
                                         :labelFunction="labelEmpleado">
                            </InputSelect>
                            <InputDate label="Fecha registro"
                                       v-model="asignacion_items.asi_fecha_registro"></InputDate>
                        </div>
                        <br>
                        <div class="nj-title-1">Items</div>
                        <SearchBox label="Item"
                                   itemKey="ord_id"
                                   itemValue="ord_id"
                                   :source="productos"
                                   :searchFunction="buscarProducto"
                                   @selectItem="agregarProducto"
                                   :labelFunction="labelProductoAlmacen"></SearchBox>
                        <br>
                        <b-table :data="asignacion_items.lista_asignacion_items_detalle">
                            <template slot-scope="props">
                                <b-table-column label="Codigo"
                                                header-class="is-info">{{ props.row.pal_id }}</b-table-column>
                                <b-table-column label="Producto"
                                                header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                                <b-table-column label="Cantidad"
                                                header-class="is-info">
                                    <input type="text"
                                           class="nj-text"
                                           v-model="props.row.aid_cantidad">
                                </b-table-column>
                                <b-table-column label="Notas"
                                                header-class="is-info">
                                    <input type="text"
                                           class="nj-text"
                                           v-model="props.row.aid_notas">
                                </b-table-column>
                                <b-table-column label="Opciones"
                                                header-class="is-info"
                                                style="width: 80px;">
                                    <div class="nj-flx">
                                        <button class="nj-button icon c-red"
                                                title="Retirar"
                                                @click="retirarProducto(props.row.pal_id)"><i
                                               class="mdi mdi-delete"></i></button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </template>
            <template #bottom>
                <Button label="Registrar"
                        icon="save"
                        @click="registrar()"></Button>
            </template>
        </Box>
        <HistorialAsignaciones v-if="showHistorial"
                               :filters="filters"
                               :titulo="titulo"
                               @close="closeHistorial()">
        </HistorialAsignaciones>
    </div>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { LabelService, AsignacionItemsService, EmpleadoService, ProductoAlmacenService, ResponseStatus, UsuarioService } from "../../services"
import OpcionesService from "../../services/OpcionesService"
import { Validator } from "../../util"
import DateTime from "../../util/dateTime"
import Toast from "../../util/toast"
import { Box, Button, InputSelect, InputText, SearchBox } from "../components"
import InputDate from "../components/InputDate.vue"
import Usuario from '../usuario/Usuario.vue'
import AsignacionItems from './AsignacionItems.vue'
import HistorialAsignaciones from "./HistorialAsignaciones"

export default {
    name: "RegistrarAsignacionItems",
    components: {
        HistorialAsignaciones,
        Box,
        InputText,
        InputSelect,
        SearchBox,
        Button,
        InputDate,
    },
    data() {
        return {
            asignacion_items: {
                usu_registrador: UsuarioService.getUsuario().usu_id,
                emp_solicitante: null,
                emp_autorizador: null,
                asi_fecha_registro: null,
                pry_id: null,
                alm_id: null,
                lista_asignacion_items_detalle: [],
            },
            emp_solicitante_nombre: null,
            filters: {
                emp_solicitante: null,
                prv_id: null,
                pal_id: null,
                alm_id: null
            },
            titulo: "",
            emp_autorizador_nombre: null,
            prv_nombre: null,
            showHistorial: false,
            solicitantes: [],
            autorizadores: [],
            productos: [],
            almacenes: [],
        }
    },
    methods: {
        close({
            view = "",
            buscar = false
        }) {
            this.reiniciarListas()
            this.$emit("close", {
                view,
                buscar
            })
        },
        reiniciarListas() {
            this.solicitantes = []
            this.autorizadores = []
            this.productos = []
        },
        filterUsuario(items, param) {
            if (param != null && param != "") {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        buscarEmpleado() {
            AsignacionItemsService
                .buscarEmpleado({
                    pry_id: UsuarioService.getProject()
                })
                .then(response => {
                    this.autorizadores = response.data
                    this.solicitantes = response.data
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        filterAlmacen(items, param) {
            if (param != null && param != "") {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelAlmacen(item) {
            return LabelService.almacen(item)
        },
        labelEmpleado(item) {
            return UsuarioService.isCoorporative()
                ? LabelService.empleadoProyecto(item)
                : LabelService.empleado(item)
        },
        labelProductoAlmacen(item) {
            return LabelService.productoAlmacenSerieStock(item)
        },
        buscarProducto(prv_nombre) {
            if (Validator.isNull(this.asignacion_items.alm_id)) {
                Toast.warn("Debe ingresar el almacen")
                return
            }
            if (Validator.isNull(this.asignacion_items.emp_solicitante)) {
                Toast.warn("Debe ingresar el solicitante")
                return
            }
            if (Validator.isNull(this.asignacion_items.emp_autorizador)) {
                Toast.warn("Debe ingresar al autorizador")
                return
            }
            ProductoAlmacenService
                .buscarRapido({
                    producto_almacen: {
                        prv_nombre,
                        alm_id: this.asignacion_items.alm_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.productos = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        agregarProducto(item) {
            const prod = this.asignacion_items.lista_asignacion_items_detalle.find(i => i.pal_id == item.pal_id)
            if (!prod) {
                this.asignacion_items.lista_asignacion_items_detalle.push({
                    prv_id: item.prv_id,
                    pal_id: item.pal_id,
                    prv_nombre: item.prv_nombre,
                    aid_cantidad: 1,
                })
                this.productos = []
            }
            else {
                Toast.error("El producto ya ha sido agregado")
            }
        },
        retirarProducto(pal_id) {
            this.asignacion_items.lista_asignacion_items_detalle =
                this.asignacion_items.lista_asignacion_items_detalle.filter(item => item.pal_id != pal_id)
        },
        asignarPoryecto(almacen) {
            // asignando el ID del proyecto a la asignación
            if (almacen) {
                const pry_id =
                    UsuarioService.getUsuario().usu_nivel == 1
                        ? almacen.pry_id
                        : UsuarioService.getUsuario().pry_id
                this.asignacion_items.pry_id = pry_id
            }
        },
        registrar() {
            if (this.asignacion_items.pry_id) {
                if (Validator.isNull(this.asignacion_items.alm_id)) {
                    Toast.warn("Debe ingresar el almacen")
                    return
                }
                if (Validator.isNull(this.asignacion_items.emp_solicitante)) {
                    Toast.warn("Debe ingresar el solicitante")
                    return
                }
                if (Validator.isNull(this.asignacion_items.emp_autorizador)) {
                    Toast.warn("Debe ingresar al autorizador")
                    return
                }
                if (Validator.isNull(this.asignacion_items.asi_fecha_registro)) {
                    Toast.warn("Debe ingresar la fecha de registro")
                    return
                }
                if (Validator.isEmpty(this.asignacion_items.lista_asignacion_items_detalle)) {
                    Toast.warn("Debe ingresar la fecha de registro")
                    return
                }
                AsignacionItemsService
                    .registrar({
                        asignacion_items: this.asignacion_items
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.close({
                                buscar: true
                            })
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
            else {
                Toast.error("No puedes realizar la asignación por que no estas asignado a ningun proyecto")
            }
        },
        openHistorialxSolicitante(solicitante) {
            this.showHistorial = true
            this.titulo = "Historial de asignaciones por solicitante"
            this.filters.emp_solicitante = solicitante.emp_id
        },
        openHistorialxItem(item) {
            this.showHistorial = true
            this.titulo = "Historial de asignaciones por item"
            this.filters.pal_id = item.pal_id
        },
        closeHistorial() {
            this.showHistorial = false
            this.filters.pal_id = null
        },
    },
    mounted() {
        this.asignacion_items.asi_fecha_registro = DateTime.todayString()
        AsignacionItemsService
            .obtenerAlmacenes({
                pry_id: UsuarioService.getProject()
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.almacenes = response.data
                    this.asignacion_items.asi_fecha_registro = DateTime.todayString()
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
            .finally(() => {
                this.buscarEmpleado()
            })

    },
}
</script>

<style scoped></style>